import { useEffect, useState } from 'react';
import { TicketPercent, X } from 'lucide-react';
import { studioApi } from '@/lib/studioApi';
import '@/styles/studio-shop.css';

// Shared links like /?code=SOMMER10 activate the code for this visitor's cart.
export const DiscountLink = () => {
  const [note, setNote] = useState(null);
  useEffect(() => {
    const url = new URL(window.location.href), code = url.searchParams.get('code');
    if (!code || url.pathname.startsWith('/verwaltung')) return;
    url.searchParams.delete('code'); window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    studioApi('/cart/discount', { method: 'POST', body: { code } })
      .then(cart => { window.dispatchEvent(new Event('cart-changed')); setNote({ ok: true, text: `Rabattcode ${cart.discount?.code || code.toUpperCase()} ist aktiviert${cart.discount?.label ? ` · ${cart.discount.label}` : ''}. Er wird an der Kasse abgezogen.` }); })
      .catch(e => setNote({ ok: false, text: e.message }));
  }, []);
  useEffect(() => { if (!note) return; const t = setTimeout(() => setNote(null), 8000); return () => clearTimeout(t); }, [note]);
  if (!note) return null;
  return <div className={`discount-link-note ${note.ok ? '' : 'is-error'}`} role="status" data-testid="discount-link-note"><TicketPercent size={17} /><span>{note.text}</span><button type="button" onClick={() => setNote(null)} aria-label="Hinweis schließen" data-testid="discount-link-close"><X size={14} /></button></div>;
};
